import React, { useContext, useEffect, useState } from 'react';
import { Modal, Button, Form, Col, Row, FloatingLabel } from 'react-bootstrap';
import { CountContext, ParentContext, CompanyContext, StateContext } from '../../layouts/Dashboard/LayoutDashboard';
import Select, { createFilter } from 'react-select';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import CustomOption from '../../utils/Elements/CustomOption';
import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';

export const CompanyForm = ({ showModal, closeModal, companyInfo, openContactForm, refreshIndividualOptions }) => {
  const api = process.env.REACT_APP_API_ENDPOINT;
  const forecastFamilyEndpoint = `${api}/v1/ForecastFamilies`;
  //const statesEndpoint = `${api}/v1/states`;
  const createProspectEndpoint = `${api}/v1/customers/prospect`;
  const salesRepsEndpoint = `${api}/v1/individuals/salesreps`;
  const CGOM_VariablesEndPoint = `${api}/v1/CGOM_Variables`;
  const parentsSearch = `${api}/v1/parents/search?searchterm=`;
  const individualsSearch = `${api}/v1/individuals/search?searchterm=`;
  const associationsEndpoint = `${api}/v1/associations/individual`;

  const { setCompanyCount } = useContext(CountContext);
  const { allParents, setAllParents, selectedParentID } = useContext(ParentContext); //this is the Trend Groups
  const { allCompanies, setAllCompanies, selectedCompanyID, selectedCompanyParentID } = useContext(CompanyContext);
  const { allStates } = useContext(StateContext);

  const [forecastFamilies, setForecastFamilies] = useState([]);
  //const [states, setStates] = useState([]);

  const [salesReps, setSalesReps] = useState([]); //same as AccountType or AccountOwner
  const [editMode, setEditMode] = useState(false);
  const [duplicateCompany, setDuplicateCompany] = useState(false);
  const [validated, setValidated] = useState(false);
  const [identity, setIdentity] = useState({});

  const [password, setPassword] = useState("");
  const [CGOMVariable, setCGOMVariable] = useState("");
  const [passwordValid, setPasswordValid] = useState(false);

  const [profile, setProfile] = useState({
    CustomerID: 0,
    CustomerName: "",
    TrendGroup: null,
    ForecastFamily: null,
    CompanyAddress: "",
    CompanyAddress2: "",
    CompanyCity: "",
    CompanyState: null,
    CompanyZip: "",
    CompanyUrl: "",
    CompanyPhone: "",
    CompanyFax: "",
    AccountType: null,
    Association: null,
  });

  const [associations, setAssociations] = useState([]); //all company Associations for this individual

  const getStoredToken = () => {
    return localStorage.getItem('token');
  };

  const storedToken = getStoredToken();

  const clearProfile = () => {
    setProfile({
      CustomerID: 0,
      CustomerName: "",
      TrendGroup: null,
      ForecastFamily: null,
      CompanyAddress: "",
      CompanyAddress2: "",
      CompanyCity: "",
      CompanyState: null,
      CompanyZip: "",
      CompanyUrl: "",
      CompanyPhone: "",
      CompanyFax: "",
      AccountType: null,
      Association: null,  //the currently selected association
    });

  };

  const showFailedMsg = () => {
    toast.error("Failed to update propsect", {
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 5000,
      paueOnHover: true,
      theme: 'colored'
    });
  };

  const handleProfileChange = (event) => {
    const { name, value } = event.target;

    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));

    if (!editMode && name === "CustomerName") {
      setProfile((prevProfile) => ({
        ...prevProfile,
        "TrendGroup": { label: value, value: value },
      }));
    }

  };

  const handleTrendGroupChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "TrendGroup": value,
    }));
  };

  const handleCompanyStateChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "CompanyState": value,
    }));
  };

  const handleForecastFamilyChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "ForecastFamily": value,
    }));
  };

  const handleAccountTypeChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "AccountType": value,
    }));
  };

  const handlePasswordChange = (event) => {
    const password = event.target.value.trim();
    setPassword(password);
  };

  const handlePasswordSubmit = () => {
    console.log("handlePasswordSubmit");
    console.log(password);
    setPasswordValid(password === CGOMVariable.VariableValue);
    setPassword("");
  };

  const handleAddIndividual = () => {
    openContactForm(profile.Association);
  };

  const updateAllCompaniesList = (customer) => {

    //company may be new or company name or trend group may have changed

    //try to locate the company
    let ndx = allCompanies.findIndex(x => x.value === customer.CustomerID);

    if (ndx === -1 || allCompanies[ndx].label !== customer.CustomerDisplayName || allCompanies[ndx].TrendGroupId !== customer.TrendGroupNumber) {
      //not found or changed

      let a = allCompanies;
      if (ndx !== -1) {
        //changed - remove from list (sort may be different)
        a.splice(ndx, 1);
      }

      //add to the sorted list
      for (let i = 0, len = a.length; i < len; i++) {
        if (customer.CustomerDisplayName.toLowerCase() < a[i].label.toLowerCase()) {
          a.splice(i, 0, { value: customer.CustomerID, label: customer.CustomerDisplayName, TrendGroupId: customer.TrendGroupNumber });
          break;
        }
      }
      setAllCompanies(a);

    }

  };

  const updateAllParentsList = (customer) => {

    //try to locate the parent
    let ndx = allParents.findIndex(x => x.value === customer.TrendGroupNumber);

    if (ndx === -1 || allParents[ndx].label !== customer.TrendGroupName) {
      //not found or changed

      let a = allParents;
      if (ndx !== -1) {
        //changed - remove from list (sort may be different)
        a.splice(ndx, 1);
      }

      //add to the sorted list
      for (let i = 0, len = a.length; i < len; i++) {
        if (customer.TrendGroupName.toLowerCase() < a[i].label.toLowerCase()) {
          a.splice(i, 0, { value: customer.TrendGroupNumber, label: customer.TrendGroupName });
          break;
        }
      }
      setAllParents(a);
    }

  };

  const submitCompany = async () => {

    const prospectData = {
      EmployeeUID: identity.sub,
      SelectedParentID: selectedParentID,
      SelectedCompanyID: selectedCompanyID,
      ID: editMode ? profile.CustomerID : 0,
      Company: profile.CustomerName,
      TrendGroupName: profile.TrendGroup.label, //if TrendGroupNumber = 0 then this creates a new trend group
      TrendGroupNumber: (profile.TrendGroup && Number.isInteger(profile.TrendGroup.value) ? profile.TrendGroup.value : 0),
      ForecastFamily: profile.ForecastFamily.value,
      Address1: profile.CompanyAddress,
      Address2: profile.CompanyAddress2,
      City: profile.CompanyCity,
      State: profile.CompanyState.value,
      Zip: profile.CompanyZip,
      Url: profile.CompanyUrl,
      Phone: profile.CompanyPhone,
      Fax: profile.CompanyFax,
      AccountTypeID: profile.AccountType.value,
      IndividualAssociations: associations,  //pass in all the associations and the backend will figure out adds and drops
    }

    console.log(prospectData);


    try {

      const response = await fetch(createProspectEndpoint, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${storedToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(prospectData)
      });

      if (response.ok) {
        const data = await response.json();

        console.log(data);

        if (data.Success) {

          setDuplicateCompany(false);
          setCompanyCount(data.UnfilteredCount);

          updateAllCompaniesList(data.Customer)
          updateAllParentsList(data.Customer)

          toast.success(editMode ? "Prospect Updated!" : "Prospect Added!", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
            paueOnHover: true,
            theme: 'colored'
          });

          closeModal();

        } else if (data.DuplicateCompany) {

          setDuplicateCompany(true);

        } else {
          showFailedMsg();
        }

      } else {
        showFailedMsg();
      }
    } catch (error) {
      showFailedMsg();
    }
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    //form and manual validations needed for react-selects
    if (form.checkValidity() &&
      (profile.TrendGroup && profile.TrendGroup.label !== "") &&
      (profile.ForecastFamily && profile.ForecastFamily.value !== 0) &&
      (profile.CompanyState && profile.CompanyState.value !== "") &&
      (profile.AccountType && profile.AccountType.value !== 0)
    ) {
      await submitCompany();
    }
    setValidated(true);

  };

  //one-time startup initializations
  useEffect(() => {

    const fetchCGOMVariables = async () => {

      try {
        const response = await fetch(CGOM_VariablesEndPoint + `?VariableName=AccountOwnerPassword`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          }
        });
        if (response.ok) {
          const data = await response.json();
          setCGOMVariable(data);
        } else {
          console.error('Failed to fetch CGOM_Variables');
        }
      } catch (error) {
        console.error('Failed to fetch CGOM_Variables');
      }


    };

    const fetchSalesReps = async () => {
      try {
        const response = await fetch(salesRepsEndpoint + `?parentId=0&companyId=-1`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          }
        });
        if (response.ok) {
          const data = await response.json();
          setSalesReps(data);
        } else {
          console.error('Failed to fetch sales reps');
        }
      } catch (error) {
        console.error('Failed to fetch sales reps');
      }
    };

    const fetchFixedForecast = async () => {
      try {
        const response = await fetch(forecastFamilyEndpoint, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          }
        });
        if (response.ok) {
          const data = await response.json();
          setForecastFamilies(data);
        } else {
          console.error('Failed to fetch data');
        }
      } catch (error) {
        console.error('Failed to fetch data');
      }
    };

    //const fetchFixedStates = async () => {
    //  try {
    //    const response = await fetch(statesEndpoint, {
    //      method: 'GET',
    //      headers: {
    //        Authorization: `Bearer ${storedToken}`,
    //        'Content-Type': 'application/json',
    //      }
    //    });
    //    if (response.ok) {
    //      const data = await response.json();
    //      setStates(data);
    //    } else {
    //      console.error('Failed to fetch data');
    //    }
    //  } catch (error) {
    //    console.error('Failed to fetch data');
    //  }
    //};

    const fetchAccount = async () => {
      try {
        //console.log("account: ", storedToken);
        const identity = jwtDecode(storedToken);
        setIdentity(identity);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    if (storedToken) {
      fetchAccount();
      fetchCGOMVariables();
      //fetchFixedStates();
      fetchFixedForecast();
      fetchSalesReps();
    } else {
      console.log('Token not found in localStorage');
    }
  }, [])

  //handle open and close modal initializations
  useEffect(() => {

    if (showModal && storedToken) {
      //open modal

      if (companyInfo && Object.keys(companyInfo).length > 0) {
        setEditMode(true);
        console.log(companyInfo)
        setProfile((prevProfile) => ({
          ...prevProfile,
          CustomerID: companyInfo.CustomerID,
          CustomerName: companyInfo.CompanyName,
          TrendGroup: (allParents.find(x => x.value === companyInfo.TrendGroupNumber)),
          ForecastFamily: (forecastFamilies.find(x => x.value === companyInfo.ForecastFamily)),
          CompanyAddress: companyInfo.CompanyAddress,
          CompanyAddress2: companyInfo.CompanyAddress2,
          CompanyCity: companyInfo.CompanyCity,
          CompanyState: (allStates.find(x => x.value === companyInfo.CompanyState)),
          CompanyZip: companyInfo.CompanyZip,
          CompanyPhone: companyInfo.CompanyPhone,
          CompanyWebsite: companyInfo.WhiteLabelUrl,
          AccountType: (salesReps.find(x => x.value === companyInfo.AccountTypeID)),
          Association: null,
        }));

        fetchAssociations();


      } else {
        setEditMode(false);

        //locate the selected parent or selected companies parent to initialize parent dropdown
        let id = selectedCompanyParentID ? selectedCompanyParentID : (selectedParentID ? selectedParentID : 0);
        let parent = (allParents.find(x => x.value === id));

        setProfile((prevProfile) => ({
          ...prevProfile,
          CustomerID: selectedCompanyID,
          CustomerName: "",
          //TrendGroup: null,
          TrendGroup: parent,
          ForecastFamily: (forecastFamilies.find(x => x.value === 1)), //1 = new business
          CompanyAddress: "",
          CompanyAddress2: "",
          CompanyCity: "",
          CompanyState: null,
          CompanyZip: "",
          CompanyPhone: "",
          AccountType: null,
          Association: null,
        }));
      }

    } else {
      //close modal
      clearProfile();
      setPasswordValid(false);
      setPassword("");
      setValidated(false);
    }

  }, [showModal]);

  const loadParentOptions = async (searchterm) => {

    let results = [];

    const response = await fetch(parentsSearch + searchterm, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };

  const loadIndividualOptions = async (searchterm) => {

    let results = [];

    const response = await fetch(individualsSearch + searchterm, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${storedToken}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      const data = await response.json();
      results = data.results;
    }

    return results;
  };

  const handleIndividualAssociationChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      "Association": value,
    }));
  };

  const addAssociation = () => {

    //add the entry to the sorted list
    if (associations.length === 0) {
      associations.push(profile.Association);
    } else {
      let didWork = false;
      for (let i = 0; i < associations.length; i++) {
        if (associations[i].label > profile.Association.label) {
          associations.splice(i, 0, profile.Association)
          didWork = true;
          break;
        }
      }
      if (!didWork) associations.push(profile.Association);
    }

    setAssociations(associations);

    //this will clear the company dropdown
    setProfile((prevProfile) => ({
      ...prevProfile,
      association: null
      ,
    }));

  };

  const deleteAssociation = (ndx) => {
    let l = associations.map(a => ({ ...a }));
    l.splice(ndx, 1);
    setAssociations(l);
  };

  const fetchAssociations = async () => {

    setAssociations([]);

    if (companyInfo && companyInfo.CustomerID) {
      try {
        const response = await fetch(associationsEndpoint + '/' + companyInfo.CustomerID, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            EmployeeUID: identity.sub,
            'Content-Type': 'application/json',
          }
        });
        if (response.ok) {
          const data = await response.json();
          setAssociations(data);
        } else {
          console.error('Failed to fetch associations');
        }
      } catch (error) {
        console.error('Failed to fetch associations', error);
      }
    }

  };

  return (
    <Modal show={showModal} onHide={closeModal} backdrop="static">
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{editMode ? (companyInfo && companyInfo.CompanyName ? companyInfo.CompanyName : 'Edit Prospect') : 'Add New Prospect'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="CustomerName">
              <FloatingLabel controlId="CustomerName" label="Company" className="w-100 required">
                <Form.Control
                  defaultValue={profile.CustomerName}
                  readOnly={false}
                  name='CustomerName'
                  type="text"
                  placeholder="Company"
                  required
                  isInvalid={duplicateCompany}
                  onChange={handleProfileChange}
                />
                <Form.Control.Feedback type="invalid">{duplicateCompany ? 'Company Name is already in use.' : 'Company Name is required.'}</Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="TrendGroup">
              <FloatingLabel controlId="TrendGroupId" label="Company Parent" className="w-100 floating-select required">
                <AsyncCreatableSelect
                  name="trendGroup"
                  className={validated ? (profile.TrendGroup && profile.TrendGroup.label !== "" ? "companyform-dropdown valid" : "companyform-dropdown invalid") : "companyform-dropdown"}
                  classNamePrefix="select"
                  isClearable={true}
                  //isSearchable={true}
                  cacheOptions
                  loadOptions={loadParentOptions}
                  defaultOptions={true}
                  value={profile.TrendGroup}
                  onChange={handleTrendGroupChange}
                />
                {(validated && !(profile.TrendGroup && profile.TrendGroup.label !== "")) ?
                  <div className="custom-error-label">Company Parent is required.</div>
                  : null}
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="ForecastFamily">
              <FloatingLabel controlId="ForecastFamily" label="Forecast Family" className="w-100 floating-select required">

                <Select
                  name="forecastfamily"
                  className={validated ? (profile.ForecastFamily && profile.ForecastFamily.value !== 0 ? "companyform-dropdown valid" : "companyform-dropdown invalid") : "companyform-dropdown"}
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={forecastFamilies}
                  value={profile.ForecastFamily}
                  onChange={handleForecastFamilyChange}
                  filterOption={createFilter({ ignoreAccents: false })} //this for performance
                  components={{ Option: CustomOption }} //this for performance
                />
                {(validated && !(profile.ForecastFamily && profile.ForecastFamily.value !== 0)) ?
                  <div className="custom-error-label">Forecast Family is required.</div>
                  : null}

              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-2' as={Col} md="6">
            <Form.Group as={Col} md="12" controlId="CompanyAddress">
              <FloatingLabel controlId="CompanyAddress" label="Address" className="w-100 required">
                <Form.Control defaultValue={profile.CompanyAddress} name='CompanyAddress' required type="text" placeholder="Address" onChange={handleProfileChange} />
                <Form.Control.Feedback type="invalid">{'Company Address is required.'}</Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="CompanyAddress2">
              <FloatingLabel controlId="CompanyAddress2" label="Address 2" className="w-100">
                <Form.Control defaultValue={profile.CompanyAddress2} name='CompanyAddress2' placeholder="Address 2" onChange={handleProfileChange} />
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="CompanyCity">
              <FloatingLabel controlId="CompanyCity" label="City" className="w-100 required">
                <Form.Control defaultValue={profile.CompanyCity} name='CompanyCity' required type="text" placeholder="City" onChange={handleProfileChange} />
                <Form.Control.Feedback type="invalid">{'Company City is required.'}</Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-2'>
            <Form.Group as={Col} md="6" controlId="CompanyState">
              <FloatingLabel controlId="CompanyState" label="State" className="w-100 floating-select required">

                <Select
                  name="state"
                  className={validated ? (profile.CompanyState && profile.CompanyState.value !== "" ? "companyform-dropdown valid" : "companyform-dropdown invalid") : "companyform-dropdown"}
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={allStates}
                  value={profile.CompanyState}
                  onChange={handleCompanyStateChange}
                  filterOption={createFilter({ ignoreAccents: false })} //this for performance
                  components={{ Option: CustomOption }} //this for performance
                />
                {(validated && !(profile.CompanyState && profile.CompanyState.value !== "")) ?
                  <div className="custom-error-label">Company State is required.</div>
                  : null}

              </FloatingLabel>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="CompanyZip">
              <FloatingLabel controlId="CompanyZip" label="Zip" className="w-100 required">
                <Form.Control defaultValue={profile.CompanyZip} name='CompanyZip' required type="text" placeholder="Zip" onChange={handleProfileChange} />
                <Form.Control.Feedback type="invalid">{'Company Zip is required.'}</Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="CompanyUrl">
              <FloatingLabel controlId="CompanyUrl" label="Company Website" className="w-100">
                  <Form.Control defaultValue={profile.CompanyWebsite} name='CompanyUrl' type='text' placeholder='Company Website' onChange={handleProfileChange}/>
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="CompanyPhone">
              <FloatingLabel controlId="CompanyPhone" label="Phone" className="w-100 required">
                <Form.Control defaultValue={profile.CompanyPhone} name='CompanyPhone' required type="text" placeholder="Phone" onChange={handleProfileChange} />
                <Form.Control.Feedback type="invalid">{'Company Phone is required.'}</Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="CompanyFax">
              <FloatingLabel controlId="CompanyFax" label="Fax" className="w-100">
                <Form.Control defaultValue={profile.CompanyFax} name='CompanyFax' placeholder="Fax" onChange={handleProfileChange} />
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-2'>
            <Form.Group as={Col} md={editMode ? "6" : "12"} controlId="AccountType">
              <FloatingLabel controlId="AccountTypeID" label="Account Owner" className="w-100 floating-select required">
                <Select
                  menuPosition={'fixed'} //this to allows option menu to open on top when there is not room to open on bottom
                  menuPortalTarget={document.body} //this to fix z-index issue on using react select in a modal
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 })
                  }}
                  name="AccountType"
                  className={validated ? (profile.AccountType && profile.AccountType.value !== 0 ? "companyform-dropdown valid" : "companyform-dropdown invalid") : "companyform-dropdown"}
                  classNamePrefix="select"
                  isDisabled={editMode && !passwordValid}
                  isClearable={true}
                  isSearchable={true}
                  options={salesReps}
                  value={profile.AccountType}
                  onChange={handleAccountTypeChange}
                  filterOption={createFilter({ ignoreAccents: false })} //this for performance
                  components={{ Option: CustomOption }} //this for performance
                />
                {(validated && !(profile.AccountType && profile.AccountType.value !== 0)) ?
                  <div className="custom-error-label">Account Owner is required.</div>
                  : null}
              </FloatingLabel>
            </Form.Group>
            {editMode ?
              <Form.Group as={Col} md="6" controlId="password">
                <FloatingLabel controlId="password" label="password" className="w-100">
                  <Form.Control
                    name='password'
                    type="password"
                    placeholder="password"
                    onChange={handlePasswordChange}
                    onBlur={handlePasswordSubmit}
                  />
                </FloatingLabel>
              </Form.Group>
              : null}
          </Row>
          
          <Row className='mb-2'>
            <Form.Group as={Col} md="12" controlId="association">
              <Form.Label hidden>Individual Association</Form.Label>
              <FloatingLabel controlId="association" label="Individual Association" className="w-100 floating-select">
                <AsyncSelect
                  key={refreshIndividualOptions} //this is the magic bit that forces the reload
                  name="association"
                  className="filter-contact-association"
                  classNamePrefix="select"
                  isClearable={true}
                  //isSearchable={true}
                  cacheOptions
                  loadOptions={loadIndividualOptions}
                  defaultOptions={true}
                  value={profile.Association}
                  onChange={handleIndividualAssociationChange}
                />
              </FloatingLabel>
            </Form.Group>
          </Row>

          <Row className='mb-2'>

              <Form.Group as={Col} md="6">
                <Button variant="primary" onClick={handleAddIndividual}>Add New Contact</Button>
              </Form.Group>

            <Form.Group as={Col} md="6" controlId="addassociation2">
              <Button
                disabled={!(profile && profile.Association && profile.Association.value) || profile.Association.value === 0}
                variant="primary"
                className="contact-add-association-button"
                onClick={addAssociation}>
                Add Contact Association
              </Button>
            </Form.Group>
          </Row>

          <Row className='mb-0'>
            <Form.Group as={Col} md="12" controlId="association">
              <div className="association-box">
                <div className="association-title">Individual Associations:</div>
                <ul>
                  {associations.map((association, index) =>
                    <li key={index} className="association-item">

                      <div className="association-item-grid">

                        <Button className="association-delete-button" title="Remove Association" onClick={() => deleteAssociation(index)}>
                          <i className="fa fa-close"></i>
                        </Button>

                        <span>{association.label}</span>

                      </div>

                    </li>
                  )}
                </ul>
              </div>
              {(associations.length !== 0) ?
                <div className="association-list-note">{associations.length} associations found.</div>
                : null}
            </Form.Group>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}